import { Link, Navigate, useNavigate } from "react-router-dom";
import { reg_doodle, textLogo } from "../../constant/import";
import { Button, InputField } from "../../components/forms";
import { emailReg, textReg } from "../../utils/regex";
import { useForm } from "react-hook-form";
import { TfiClose } from "react-icons/tfi";
import { useStateGetter } from "../../hooks/statehooks/UseStateGettersHook";
import { useStateSetter } from "../../hooks/statehooks/UseStateSettersHook";
import { onGetOtp, onResetPassword } from "../../services/auth/user";
import { toast } from "react-toastify";
import { SiMinutemailer } from "react-icons/si";
import { FaCheck } from "react-icons/fa";
import { IoMdClose } from "react-icons/io";
import { useEffect, useState } from "react";

const ResetPassSettings = () => {
  const { handleSubmit, control, watch } = useForm();
  const { isTabletOrMobile } = useStateGetter();
  const { setVerifyEmail } = useStateSetter();
  const navigate = useNavigate();
  const { setLoading, showModal, setShowModal } = useStateSetter();
  const wacthpasswordfild = watch(["password"]);
  const wacthconfpasswordfild = watch(["conpassword"]);
  const watchedFields = watch(["password", "conpassword"]);
  const [confpass, setconfpass] = useState("");
  const [pass, setpass] = useState("");

  const { verifyemail } = useStateGetter();
  
  useEffect(()=>{
    if(verifyemail==""){
      navigate('/')
    }})

  useEffect(() => {
    setconfpass(wacthconfpasswordfild[0]);
  }, [wacthconfpasswordfild]);

  useEffect(() => {
    setpass(wacthpasswordfild[0]);
  }, [wacthpasswordfild]);

  const areFieldsFilled = watchedFields.every(
    (field) => field !== "" && field !== undefined
  );
  const GetOTP = (props: any) => (
    <div className=" flex flex-col justify-center items-center">
      <p className=" font-medium text-textbg  my-2">
        {" "}
        OTP Verification required{" "}
      </p>
      <p className="font-light text-textbg  text-xs text-center">
        {" "}
        We will send a One Time Password (OTP) to {props.email}
      </p>
      <div className=" gap-6 w-full flex ">
        <Button
          outlined
          disabled={false}
          text="Cancel"
          onBtnClick={() => {
            setShowModal(false);
          }}
        />
        <Button
          disabled={false}
          text="Get OTP"
          onBtnClick={async () => {
            setLoading(true);
            var postdata = { email: props.email };
            var res = await onGetOtp(postdata);
            setLoading(false);
            toast("OTP sent to your email");
            navigate("/verifyreset");
            setShowModal(false);
          }}
        />
      </div>{" "}
    </div>
  );
  const onSubmit = async (data: any) => {
    var postdata = {
      email: verifyemail,
      password: data.password,
    };

    console.log(postdata);
    setLoading(true);
    try {
      var response = await onResetPassword(postdata);

      if (response.message) {
        toast(response.message);
      }

      if(response.success){

        navigate('/')
      }
    } catch (e: any) {
      console.log(e);
      toast.error(e);
      setLoading(false);
    }
    setLoading(false)
  };

  return (
    <div className="p-4 md:p-10 w-screen h-screen bg-customGray  flex flex-col md:grid md:grid-cols-2 items-center justify-center">
       
      <div className="bg-white  w-[100%] md:w-[458px] p-6  md:min-h-[80vh]  md:mx-20 md:py-2 md:px-20 shadow flex flex-col  justify-center  ">
        

        <TfiClose
          className="m-4"
          onClick={() => {
            navigate(-1);
          }}
          size={30}
        />

        <p className="font-bold text-textbg text-[24px] ">
          Create New Password
        </p>
        <small className="font-light text-textbg text-xs ">
          Enter and confirm your new password below
        </small>
        <div className=" my-4">
          <InputField
            name="password"
            title="New Password"
            placeholder="Enter Your New Password"
            control={control}
            rules={{
              required: "Password is required",
            }}
            type={"password"}
          />

          <InputField
            name="conpassword"
            title="Confirm New Password"
            placeholder="Confirm Your New Password"
            control={control}
            rules={{
              required: "Password is required",
            }}
            type={"password"}
          />

          {pass && (
            <div className=" p-3 m-2">
              <p className="text-xs m-1">
                {!(pass ? pass?.length < 6 : true) ? (
                  <FaCheck className="inline text-green-400" />
                ) : (
                  <IoMdClose className=" text-red-500 inline" />
                )}{" "}
                6 characters minimum
              </p>

              <p className="text-xs m-1">
                {!/\d/.test(pass) ? (
                  <IoMdClose className=" text-red-500 inline" />
                ) : (
                  <FaCheck className="inline text-green-400" />
                )}{" "}
                Contains a number
              </p>

              <p className="text-xs m-1">
                {!/[!@#$%^&*(),.?":{}|<>]/.test(pass) ? (
                  <IoMdClose className=" text-red-500 inline" />
                ) : (
                  <FaCheck className="inline text-green-400" />
                )}{" "}
                Atleast one special character
              </p>
            </div>
          )}
          {!(confpass == pass) && (
            <p className="text-xs text-center text-red-500">
              {" "}
              <IoMdClose className=" text-red-500 inline" /> Passwords don't
              match
            </p>
          )}

          <Button
            disabled={!areFieldsFilled}
            text="Reset"
            onBtnClick={handleSubmit(onSubmit)}
          />
        </div>
      </div>
    </div>
  );
};

export { ResetPassSettings };
